import React, { useState, useMemo } from "react";
import { toggleReport } from "../../../utils/Reports/functions";
import ReportPopUp from "../../ModalComponents/ReportPopUp";
import { FiExternalLink } from "react-icons/fi";
import { FormattedMessage } from "react-intl";

const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure two digits
    const day = String(date.getDate()).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2); // Get last two digits of the year
    return `${day}/${month}/${year}`;
};

const VisitHistory = ({ visithistory, reportLayout }) => {
    // Get today's date in the YYYY-MM-DD format
    const today = new Date();
    today.setHours(23, 59, 0, 0); // Set the time to 23:59 to compare only dates

    // Use useMemo to make visithistory responsive：New meetings were added in response to being offline
    const pastVisits = useMemo(() => {
        if (!visithistory) return [];
        return visithistory
            .filter((visit) => {
                const visitDate = new Date(visit.start_date);
                return visitDate <= today && visit.is_visited === true;
            })
            .sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
    }, [visithistory]);

    const [selectedReport, setSelectedReport] = useState(null); // Track selected report data

    return (
        <div className="rounded-md md:border md:border-gray-200">
            <div className="text-left ml-5 font-bold mb-5 mt-5">
                Historique des visites
            </div>
            <div className="pt-10 w-11/12 ml-5 ">
                {pastVisits.length ? (
                    pastVisits.map((visit, index) => (
                        <div
                            key={visit.meeting_id || index}
                            className="list-wrapper mb-10 text-xs border-b border-gray-200"
                        >
                            <div className="flex flex-row justify-between items-center pt-2 pb-2 text-left">
                                <div className="w-1/5 text-sm font-semibold">
                                    {formatDate(visit.start_date)}
                                </div>
                                <div className="w-2/5 text-sm font-semibold">
                                    {visit.user?.first_name}{" "}
                                    {visit.user?.last_name}
                                </div>
                                <div className="w-2/5 text-sm font-semibold flex items-center">
                                    {visit.type && visit.type.description && (
                                        <>
                                            {visit.type.description}
                                            <button
                                                onClick={() =>
                                                    toggleReport(
                                                        visit.report,
                                                        setSelectedReport
                                                    )
                                                } // Pass report data
                                                className="p-1 text-black text-xs rounded"
                                            >
                                                <FiExternalLink />
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <FormattedMessage id="client.no_visit_history" />
                )}
                {selectedReport && (
                    <ReportPopUp
                        togglePopup={() =>
                            toggleReport(null, setSelectedReport)
                        } // Close popup when toggled
                        reportData={selectedReport} // Pass the selected report data
                        reportLayout={reportLayout}
                    />
                )}
            </div>
        </div>
    );
};

export default VisitHistory;
